import axios from '../../../services/axiosInstance';

const baseUrl = process.env.REACT_APP_BASE_URL;

const authHeaders = (extraHeaders = {}) => ({
  ...extraHeaders,
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export async function getProductos() {
  try {
    const response = await axios.get(`${baseUrl}/productos`);
    return response;
  } catch (e) {
    console.error("Error en getProductos:", e);
    return { status: 500, data: { productos: [] } };
  }
}

export async function saveProductos(productoData) {
  try {
    const response = await axios.post(`${baseUrl}/productos`, productoData, {
      headers: authHeaders({ 'Content-Type': 'multipart/form-data' }),
    });

    return response;
  } catch (e) {
    console.error("Error al guardar producto:", e.response?.data || e);
    throw e;
  }
}

export async function updateProductos(_id, formData) {
  try {
    const response = await axios.put(`${baseUrl}/productos/${_id}`, formData, {
      headers: authHeaders({ "Content-Type": "multipart/form-data" }),
    });
    return response;
  } catch (e) {
    console.error("Error al actualizar el producto:", e);
    throw e;
  }
}

export async function deleteProductos(_id) {
  try {
    const response = await axios.delete(`${baseUrl}/productos/${_id}`, {
      headers: authHeaders(),
    });
    return response;
  } catch (e) {
    console.error("Error al eliminar producto:", e);
    throw e;
  }
}

export async function getCategorias() {
  try {
    const response = await axios.get(`${baseUrl}/categorias`);
    return response;
  } catch (e) {
    console.error("Error al obtener categorias:", e);
    throw e;
  }
}

export async function createCategoria(nombreCategoria) {
  try {
    if (!nombreCategoria || nombreCategoria.trim() === "") {
      throw new Error("El nombre de la categoria no puede estar vacio");
    }

    const response = await axios.post(`${baseUrl}/categorias`, {
      nombre: nombreCategoria.trim(),
    }, {
      headers: authHeaders(),
    });

    return response;
  } catch (e) {
    console.error("Error al crear categoria:", e);
    throw e;
  }
}

export async function togglePromocionProducto(id, enPromocion, precioPromocion) {
  try {
    const response = await axios.put(`${baseUrl}/productos/${id}/promocion`, {
      enPromocion,
      precioPromocion
    }, {
      headers: authHeaders()
    });

    return response;
  } catch (error) {
    console.error("Error al actualizar promocion:", error.response?.data || error);
    throw error;
  }
}
